export enum PRODUCT_AREA {
  HOME_PAGE = "Home Page",
}

export enum PAGE_NAME {
  HOME_PAGE = "Home Page",
}

export enum PAGE_AREA {
  SITES_LIST = "Sites List",
  RECREATE_FROM_WEBSITE_MODAL = "Website URL Modal",
  RECREATE_FROM_FIGMA_MODAL = "Import from Figma Modal",
}

export const CHOOSE_DESIGN_PARTNER_BUTTON_NAME = "Choose Design Partner";